import * as WinForm from '../winform';
import { DataService } from './data';
import { ApiLibsFn } from '../libs/host';
import { CheckLibs } from '../libs/check';
import { UserEnum } from '../enum/user';
export class UserService {
    /**
     * 获取当前用户数据
     * @returns
     */
    static user() {
        let userInfo = {};
        if (CheckLibs.isClient()) {
            try {
                userInfo = WinForm.md.getLoginInfo();
            }
            catch (error) { }
        }
        else {
            userInfo = this.getUserByBrowser();
        }
        return UserService.userTransition(userInfo) || {};
    }
    /**
     * 浏览器端获取用户信息
     * @returns
     */
    static getUserByBrowser() {
        // @ts-ignore
        if (CheckLibs.isUniApp()) {
            return this.getUserByUniApp();
        }
        let userInfo = window.localStorage.getItem(UserEnum.USERINFO);
        let userObj = {};
        try {
            userObj = JSON.parse(userInfo || '');
        }
        catch (error) {
            userObj = {};
        }
        return userObj;
    }
    /**
     * uni端获取用户信息
     */
    static getUserByUniApp() {
        // @ts-ignore
        let userInfo = uni.getStorageSync(UserEnum.USERINFO);
        return userInfo;
    }
    /**
     * 浏览器端设置用户信息
     * @param userInfo
     */
    static setUserOfBrowser(userInfo = {}) {
        window.localStorage.setItem(UserEnum.USERINFO, JSON.stringify(userInfo));
    }
    /**
     * 杭州服务返回的用户数据转换为老的数据结果（用于前端兼容）
     * @param user
     * @returns
     */
    static userTransition(user) {
        for (var key in user) {
            user[key.substring(0, 1).toUpperCase() + key.substring(1)] = user[key];
        }
        user.UserID = user.UserId || user.UserID;
        user.CompID = user.CompanyId || user.CompID || user.CompId;
        user.CompName = user.CompanyName || user.CompName;
        user.CompMdt = user.CompanyMdt || user.CompMdt;
        user.CompLogo = user.CompanyLogo;
        user.CompVipLevel = user.CompanyVipLevel;
        user.OrgID = user.OrgId || user.OrgID;
        return user;
    }
    /**
     * 获取当前登陆用户token
     * @param bearer token前是否加Bearer ，默认为false
     * @returns
     */
    static token(bearer = false) {
        //暂增加在storge中获取token
        let user = UserService.user();
        let token = user && (user.token || user.Token);
        if (!token) {
            return null;
        }
        return `${bearer ? 'Bearer ' : ''}` + token;
    }
    /**
     * 根据企业id获取是否有分类选型展示
     * @param CompID 企业id
     * @returns
     */
    static getLectoByCompid(CompID) {
        return ['0'].includes(`${CompID}`);
    }
    /**
     * 获取用户信息
     * @returns {UserInfo} 用户信息
     */
    static async getmyinfo() {
        return await DataService.get(`${ApiLibsFn().JrzzApi60}/user/getmyinfo`);
    }
    /**
     * 根据手机号查询用户列表
     * @param phone
     * @returns
     */
    static async getuserlistbyphone(phone) {
        return await DataService.get(`${ApiLibsFn().JrzzApi60}/user/getuserlistbyphone?phone=${phone}&token=${encodeURIComponent(this.token())}`);
    }
    /**
     * 无token时根据手机号查询用户列表
     * @param phone
     * @param smsVerify
     * @returns
     */
    static async getuserlistbyphoneSms(phone, smsVerify) {
        return await DataService.get(`${ApiLibsFn().JrzzApi60}/user/getuserlistbyphone?phone=${phone}&smsVerify=${smsVerify}`);
    }
    /**
     * 找回密码（其实就是重置为新的密码）
     * @param userId 账户id
     * @param phone 手机号
     * @param smsVerify 手机验证码
     * @param newPsw 新的密码
     * @returns
     */
    static async findpsw(userId, phone, smsVerify, newPsw) {
        return await DataService.post(`${ApiLibsFn().JrzzApi60}/user/findpsw`, {
            userId,
            phone,
            smsVerify,
            newPsw,
        });
    }
    /**
     * 登录 可以form表单提交的形式
     * @param type
     * @param params
     * @returns
     */
    static async login(type = 1, params) {
        return await DataService.post(`${ApiLibsFn().JrzzApi60}/user/login?type=${type}`, params);
    }
    /**
     * 大国工匠-登录-密码转Rsa
     * @param type 登录类型 10000为个人版大国工匠，20000为企业版大国工匠
     * @param accId 手机号/通号
     * @param password 密码 RSA 2048
     * @param verify 图片验证码,密码重复输错3次后要求输入
     * @returns
     */
    static async loginEncryption(type, accId, password, verify = null) {
        const option = { accId, password };
        if (verify)
            option.verify = verify;
        return await DataService.post(`${ApiLibsFn().JrzzApi60}/user/loginEncryption?type=${type}`, option);
    }
    /**注销登录信息 */
    static async logout() {
        return await DataService.post(`${ApiLibsFn().JrzzApi60}/user/logout`);
    }
    /**
     * 账号注册
     * @param userType
     * @param input
     * @param params
     * @returns
     */
    static async register(userType = 0, input, params) {
        return await DataService.post(`${ApiLibsFn().JrzzApi60}/user/register?input=${input}&userType=${userType}`, params);
    }
    /**
     * 新增活跃度接口 1为大工程师，2为客元宝
     * @param type
     */
    static setActivity(type) {
        try {
            DataService.get(`${ApiLibsFn().EngineerApi}/user/setActivity?type=${type}`);
        }
        catch (error) { }
    }
}
